/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Select_Target_Folder_AriaInputs */



/**
* | output |
* | --- |
* | "Select Target Folder" |
*
* @param {Drastic_Tech_Select_Target_Folder_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_select_target_folder_aria = /** @type {((inputs?: Drastic_Tech_Select_Target_Folder_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Select_Target_Folder_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le dossier cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona cartella di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите целевую папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar carpeta de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择目标文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットフォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फ़ोल्डर का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a pasta de destino")
	return /** @type {LocalizedString} */ ("Select Target Folder")
});